export default class IframeGenerator {
    #template =
        '<iframe src="https://[SUBDOMAIN].[HOST]/embed" width="[WIDTH]" height="[HEIGHT]" style="border: 0; margin: 0;" title="Gamification Player"></iframe>'
    #element
    #heightElement
    #widthElement

    constructor(element) {
        this.#element = element
        this.#heightElement = document.querySelector(element.dataset.gpHeightSource)
        this.#widthElement = document.querySelector(element.dataset.gpWidthSource)

        this.#bindEvents()

        this.#handleChange()
    }

    static init(selector) {
        let element = document.querySelector(selector)
        if (element) {
            new IframeGenerator(element)
        }
    }

    #bindEvents() {
        this.#heightElement.addEventListener('keyup', () => {
            this.#heightElement.value = this.#heightElement.value.replace(/[^0-9%]/g, '')
            this.#handleChange()
        })
        this.#widthElement.addEventListener('keyup', () => {
            this.#widthElement.value = this.#widthElement.value.replace(/[^0-9%]/g, '')
            this.#handleChange()
        })
    }

    #handleChange() {
        let embedCode = this.#template

        this.#element.innerText = embedCode
            .replace('[SUBDOMAIN]', this.#element.dataset.gpSubdomain)
            .replace('[HOST]', this.#element.dataset.gpHost)
            .replace('[WIDTH]', this.#widthElement.value)
            .replace('[HEIGHT]', this.#heightElement.value)
    }
}
